export const visit = (vm, at) => {
at({ "es": { "pricing-pages-ui": { "phone-supportV2": { "needHelp": "\xBFNecesitas ayuda para elegir un plan?", "stillHaveQuestions": "\xBFA\xFAn tienes preguntas sobre c\xF3mo el software de HubSpot puede ayudar a tu empresa?" } } } });
};